import { Fragment } from 'react';
import { Button } from '@heroui/react';
import { MdArrowBackIosNew } from 'react-icons/md';
import { useWizard, useMediaQuery } from 'hooks';
import Steps from './containers/index.tsx';
import { handleDisable } from './helpers';
import _ from 'lodash';
import { CarrouselSurvey, SurveyLayout } from '@/components';
import { MetaInfo, Pregunta, PreguntaRespuesta, PreguntasDetalle, SurveyStepsDetailsHandler, SurveyStepsHandler } from '@/hooks/useSurvey';
import { LuChevronRight, LuCircleCheck } from 'react-icons/lu';

interface SurveyWizardProps {
    disabled?: boolean;
    steps: Pregunta[];
    hideBack?: boolean;
    handleSurveySteps: SurveyStepsHandler;
    handleSurveyStepsDetails: SurveyStepsDetailsHandler;
    hideNext?: boolean;
    disabledNext: boolean;
    handleMenu: () => void;
    handleDone: () => Promise<void>;
    metaInfo: MetaInfo[];
    details: PreguntasDetalle[];
    answers: PreguntaRespuesta[];
}

const SurveyWizardComponent = ({
    handleSurveySteps,
    handleSurveyStepsDetails,
    steps,
    hideBack,
    hideNext,
    disabledNext,
    handleMenu,
    handleDone,
    answers,
}: SurveyWizardProps) => {
    
    const {
        activeStep,
        finalStep,
        handleNext,
        handleBack,
        numItems,
        state,
        isTouchDevice,
    } = useWizard(steps, handleMenu, handleDone);
    const xs = useMediaQuery('(min-width: 600px)');

    const item = steps[activeStep];
    const disabled = handleDisable(item);

    const BottomBar = () => {
        return (
            <div
                className={`
                    flex items-center justify-between shrink-0
                    ${isTouchDevice
                        ? 'min-h-16 w-full px-8 py-3 z-1 max-[700px]:px-5'
                        : 'py-3'
                    }
                `}
                
            >
                <div>
                    {!hideBack && (
                        <Button
                            variant={isTouchDevice ? 'light' : 'flat'}
                            onPress={handleBack}
                            startContent={isTouchDevice && <MdArrowBackIosNew className="text-4xl text-default-500" />}
                            className={isTouchDevice ? 'text-2xl' : 'text-sm'}
                            isIconOnly={!xs && isTouchDevice}
                        >
                            {xs ? 'Anterior' : (!isTouchDevice ? '' : null)}
                        </Button>
                    )}
                </div>
                <div>
                    {!hideNext && (
                        finalStep && !isTouchDevice ? (
                            <Button
                                color="primary"
                                isDisabled={disabled || disabledNext}
                                onPress={handleDone}
                            >
                                Finalizar
                            </Button>
                        ) : (
                            <Button
                                variant={isTouchDevice ? 'light' : 'flat'}
                                onPress={handleNext}
                                isDisabled={disabled || disabledNext}
                                isIconOnly={!xs && isTouchDevice}
                                endContent={
                                    isTouchDevice && (
                                        !finalStep ? (
                                            <LuChevronRight
                                                className={`text-4xl text-blue-500`}
                                                // className={`text-4xl ${disabled || disabledNext ? '' : 'text-white'}
                                                //     text-
                                                // `}
                                                // style={{ color: disabled || disabledNext ? primaryColor : undefined }}
                                                />
                                            ) : (
                                                <LuCircleCheck
                                                className={`text-5xl text-blue-500`}
                                                // className={`text-5xl ${disabled || disabledNext ? '' : 'text-white'}`}
                                                // style={{ color: disabled || disabledNext ? primaryColor : undefined }}
                                            />
                                        )
                                    )
                                }
                                className={isTouchDevice ? 'text-2xl' : 'text-sm'}
                                color='primary'
                                
                            >
                                {xs ? (finalStep ? 'Finalizar' : 'Siguiente') : (!isTouchDevice ? '' : null)}
                            </Button>
                        )
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className={'flex flex-col w-full h-full'}>
            <SurveyLayout>
                <div className="flex flex-col flex-1 justify-between w-full">
                    <div className="overflow-hidden flex-1">
                        <CarrouselSurvey numItems={numItems + 1} state={state}>
                            {steps.map((step, index) => {
                                const answersStep = _.filter(answers, (o) => o.nPregunta === step.nPregunta);
                                console.log(step)
                                return (
                                    <Fragment key={index}>
                                        {step.bMostrarSeccion ? (
                                            <div
                                                className={`py-4 ${isTouchDevice && xs ? 'flex justify-center' : ''}`}
                                            >
                                                <h4 className={`font-bold ${isTouchDevice ? 'text-2xl' : 'text-xl'}`}>
                                                    {step.cSeccion}
                                                </h4>
                                            </div>
                                        ) : (
                                            <div className="pt-4" />
                                        )}

                                        <Steps
                                            finalStep={index + 1 === steps.length}
                                            handleNext={handleNext}
                                            iStep={index}
                                            step={step}
                                            answers={answersStep}
                                            handleSurveySteps={handleSurveySteps}
                                            handleSurveyStepsDetails={handleSurveyStepsDetails}
                                        />
                                    </Fragment>
                                );
                            })}
                        </CarrouselSurvey>
                    </div>
                    {!isTouchDevice && <BottomBar />}
                </div>
            </SurveyLayout>
            {isTouchDevice && <BottomBar />}
        </div>
    );
};

export default SurveyWizardComponent;
